export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/hr_consulting.cce13bf.svg";